export default __webpack_public_path__ + "files/95c34f82688a4ea15a73b4035beac110.jpg";